import { getEmbedSearchWidgetIdFromPathname } from '#/modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';

import { hasIosUserAgent } from './hasIosUserAgent';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';

export function getAnalyticsApplicationContextProps() {
  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );

  if (embedSearchWidgetId) {
    return {
      application_context: 'search-widget',
      embed_search_widget_id: embedSearchWidgetId,
      ssr_server: HORIZON_ENABLED ? 'horizon' : 'hypernova',
    };
  }

  if (hasIosUserAgent())
    return {
      application_context: 'ios',
      ssr_server: HORIZON_ENABLED ? 'horizon' : 'hypernova',
    };

  return {
    application_context: 'web',
    ssr_server: HORIZON_ENABLED ? 'horizon' : 'hypernova',
  };
}
